module.exports = __webpack_public_path__ + "img/horizontal_1_1_0.9adb1005.png";